// Site-wide constants for Navilukallu Homestay
export const SITE = {
  name: "Navilukallu Homestay",
  tagline: "Stay • Relax • Experience Nature",
  phoneDisplay: "+91 81054 03101",
  phoneRaw: "+918105403101",
  whatsappRaw: "918105403101",
  email: "navilukalluhomestay@gmail.com",
  domain: "https://navilukalluhomestay.in",
  address: "Kamathi (V), Alur Taluk, Hassan District, Karnataka",
  location: "Between Belur & Sakleshpur, Karnataka",
  instagram: "https://www.instagram.com/reel/DRe4Do0CTFp/?igsh=aGZyMDlubnluNWIz",
  mapsShareUrl: "https://share.google/hM2qK1oP3Y826GoNx",
  // Google Maps embed for Navilukallu Homestay (Kamathi V, Alur Taluk)
  mapsEmbedSrc:
    "https://www.google.com/maps?q=Kamathi+Alur+Hassan+Karnataka&output=embed",
  portfolioUrl: "https://smartmarketingchikmagalur.netlify.app",
  creatorName: "Sunil",
};

const u = (id, w = 1400) =>
  `https://images.unsplash.com/photo-${id}?w=${w}&auto=format&fit=crop&q=70`;

const wm = (file, w = 1280) =>
  `https://commons.wikimedia.org/wiki/Special:FilePath/${file}?width=${w}`;

const OWN = "https://customer-assets.emergentagent.com/job_coffee-estate-stay-1/artifacts/";
const OWN_OLD = "https://customer-assets.emergentagent.com/job_4ce0b193-5a79-44eb-86f6-e53b216dc280/artifacts/";

export const IMAGES = {
  logo: OWN + "qii4z7oh_logo.jfif",

  heroDay: OWN_OLD + "nk6orfue_main%20day.jfif",
  heroMobile: OWN_OLD + "rqiytk17_main%20mobil.jfif",
  heroLaptop: OWN_OLD + "ql82d8gn_main%20loptop.jfif",

  roomCouple: OWN + "jrpev2lc_family%20and%20couple%20room.jfif",
  roomGroup: OWN + "7psm86dc_friends%20and%20groups%20rooms.jfif",

  food1: OWN + "1dqv0xgl_food.jfif",
  food2: OWN + "6i98dac4_food%202.jfif",
  food3: OWN + "hman6ul5_food%204.jfif", // Ottu Shavige plate

  peacock: OWN + "3wyxbk7d_peocack.jfif",
  flowersGarden: OWN + "stkpr7uw_ok.jfif",
  flowerCanopy: OWN + "phc4vj6o_flowers.jfif",
  estateShrine: OWN + "5axi29ds_cofee%20estete.jfif",
  rainDance: OWN + "mfdit32v_rain%20dance.jfif",

  // NEW sitouts
  sitoutFamily: OWN + "3ad4xktm_sit%20out.jfif",
  sitoutGroup: OWN + "jfhrfok5_sitout%202.jfif",

  // NEW attractions
  wateholeDam: OWN + "j9nc4oyg_wate.jfif",
  parvathammaBetta: OWN + "4yyg7hjr_parava.jfif",

  // External attractions - now owner-uploaded
  yagachi: OWN + "eo0ivh7k_yachi.jfif",
  belurTemple: OWN + "8kz2i3i8_belur.jfif",
  halebidu: wm("Halebidu_temple.jpg", 1400),
  manjarabad: OWN + "m7h5wpss_manjarad.jfif",

  // Yearly events
  hasanambaTemple: OWN + "ywnm9ttm_hsanba.jfif",
  sakleshpurJatre: OWN + "5bxolcoa_sakaleshapura.jfif",
};

export const ATTRACTION_MAPS = {
  watehole: "https://www.google.com/maps/search/?api=1&query=Watehole+Dam+Sakleshpur",
  parvathamma: "https://www.google.com/maps/search/?api=1&query=Parvathamma+Betta+Sakleshpur",
  yagachi: "https://www.google.com/maps/search/?api=1&query=Yagachi+Dam+Water+Sports+Hassan",
  belur: "https://www.google.com/maps/search/?api=1&query=Chennakeshava+Temple+Belur",
  halebidu: "https://www.google.com/maps/search/?api=1&query=Hoysaleswara+Temple+Halebidu",
  manjarabad: "https://www.google.com/maps/search/?api=1&query=Manjarabad+Fort+Sakleshpur",
};

export const NAV_LINKS = [
  { label: "Home", href: "#home" },
  { label: "About", href: "#about" },
  { label: "Rooms", href: "#rooms" },
  { label: "Estate", href: "#estate" },
  { label: "Rain Dance", href: "#rain-dance" },
  { label: "Food", href: "#food" },
  { label: "Sitouts", href: "#sitouts" },
  { label: "Attractions", href: "#attractions" },
  { label: "Events", href: "#events" },
  { label: "Contact", href: "#booking" },
];

export const buildWhatsAppUrl = (message = "") => {
  const text = encodeURIComponent(
    message || "Hi, I'd like to know more about Navilukallu Homestay."
  );
  return `https://wa.me/${SITE.whatsappRaw}?text=${text}`;
};
